import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  const navigate = useNavigate();

  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mb-6">
          <Icon name="Search" size={40} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">No items found</h3>
        <p className="text-sm text-muted-foreground text-center mb-6 max-w-md">
          No inventory items match your current filters. Try adjusting your search criteria or clearing filters.
        </p>
        <Button
          variant="outline"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
          iconSize={16}
        >
          Clear Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mb-6">
        <Icon name="Package" size={40} color="var(--color-primary)" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">No inventory items yet</h3>
      <p className="text-sm text-muted-foreground text-center mb-6 max-w-md">
        Get started by adding the first inventory item for this client. Use your camera to photograph furniture pieces and create detailed records.
      </p>
      <Button
        variant="default"
        onClick={() => navigate('/add-inventory-item')}
        iconName="Plus"
        iconPosition="left"
        iconSize={20}
      >
        Add First Item
      </Button>
    </div>
  );
};

export default EmptyState;